import '.hu{height:44px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.da{flex-shrink:0;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.ba{justify-content:flex-start;}.ssr-plugin'
import '.bl{gap:8px;}.ssr-plugin'
import '.dn{height:24px;}.ssr-plugin'
import '.fy{width:24px;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a1{height:100%;}.ssr-plugin'
import '.z{flex:1;}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.i3{right:8px;}.ssr-plugin'
import '.i4{background:#e8e8e9;}.ssr-plugin'
import '.i5{z-index:9999;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { IconButton } from '../IconButton/index.js'
import { Icon } from '../Icon/index.js'
import { Menu } from '../Menu/index.js'
import { ItemActions } from '../../utils/common.js'
import { Fragment, ReactNode, useEffect, useRef, useState } from 'react'
import { useDragAndDrop } from '../../hooks/useDragAndDrop.js'
import { createRoot } from 'react-dom/client'
import { Text } from '../Text/index.js'
import { CheckboxInput } from '../CheckboxInput/index.js'
import { DragPreview } from '../DragPreview/index.js'
import { flushSync } from 'react-dom'
import React from 'react'

const ShadowItem = () => {
  return (
    <div className="hu h"
      style={{
        background: colors.neutral10Adjusted,
        borderRadius: radius[12],
      }}
      onDragEnter={(e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
      }}
    />
  )
}

function getFirstFieldWithContent(item: any, fields: Record<any, any>) {
  for (const field of Object.values(fields)) {
    const content = field.render
      ? field.render(
          field.renderAccessorFn ? field.renderAccessorFn(item) : item,
          'table',
        )
      : item[field.key]

    if (typeof content === 'string') {
      return content
    }
  }

  return 'Unknown'
}

type ListItemProps = {
  item: any
  fields: Record<any, any>
  idx: number
  flushItems?: boolean
  cleanMode?: boolean
  onClick?: () => void
  selected?: boolean
  onSelectChange?: (selected: boolean) => void
  disabled?: boolean
  itemActions?: ItemActions
  onOrderChange?: (draggedId: string, targetIdx: number) => void
  onRemove?: (item?: any) => void
}

function ListItem({
  item,
  fields,
  idx,
  flushItems,
  cleanMode,
  selected,
  disabled,
  itemActions,
  onSelectChange,
  onClick,
  onOrderChange,
  onRemove,
}: ListItemProps) {
  const outerRef = useRef<HTMLDivElement>()
  const [state, setState] = useState<
    'idle' | 'being-dragged' | 'being-dragged-over-self'
  >('idle')
  const [forceHover, setForceHover] = useState(false)
  const { draggedItem, setDraggedItem } = useDragAndDrop()
  const [draggedOver, setDraggedOver] = useState<'above' | 'below'>()
  const pointerPositionRef = useRef<{ x: number; y: number }>()
  const [hover, setHover] = useState(false)

  useEffect(() => {
    function calc(e: PointerEvent) {
      pointerPositionRef.current = { x: e.clientX, y: e.clientY }
    }

    window.addEventListener('pointermove', calc, { capture: true })

    return () => {
      window.removeEventListener('pointermove', calc, { capture: true })
    }
  }, [])

  return (
    <div className="a i"
      ref={outerRef}
      onDragEnter={(e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
        if (state === 'being-dragged-over-self') return

        const rect = outerRef.current.getBoundingClientRect()
        const middle = rect.top + rect.height / 2
        setDraggedOver(e.clientY > middle ? 'below' : 'above')
      }}
      onDragLeave={(e) => {
        e.preventDefault()

        setDraggedOver(undefined)
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={(e) => {
        setHover(false)
        e.preventDefault()

        if (draggedItem && item.id === draggedItem.id) {
          if (state === 'being-dragged-over-self') {
            setState('being-dragged')
          }
        }
      }}
      onDragOver={(e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
        if (state === 'being-dragged-over-self') return

        const rect = outerRef.current.getBoundingClientRect()
        const middle = rect.top + rect.height / 2
        setDraggedOver(e.clientY > middle ? 'below' : 'above')
      }}
      onDrop={(e) => {
        e.preventDefault()
        if (!draggedItem?.id) return
        if (state === 'being-dragged-over-self') return

        const rect = outerRef.current.getBoundingClientRect()
        const middle = rect.top + rect.height / 2
        flushSync(() => {
          setDraggedOver(undefined)
          setDraggedItem(undefined)
          setState('idle')
        })

        let targetIdx = idx

        onOrderChange?.(draggedItem.id as string, targetIdx)
      }}
    >
      {(draggedOver === 'above' || state === 'being-dragged-over-self') && (
        <ShadowItem />
      )}
      <styled.div className="a0 da h a b ba bl"
        data-forcehover={forceHover}
        data-selected={selected}
        style={{
          ...(cleanMode
            ? {
                height: 32,
                borderRadius: radius[12],
                padding: '4px 8px 4px 8px',
              }
            : {
                paddingLeft: 8,
                paddingRight: itemActions ? 8 + 8 + 24 : 8,
                height: 44,
                borderRadius: flushItems ? undefined : radius[12],
              }),
          '&:hover': {
            backgroundColor: colors.neutral10Adjusted,
          },
          '& .actionButton': {
            opacity: '0%',
          },
          '&:hover .actionButton': {
            opacity: '100% !important',
          },
          '&[data-forcehover=true]': { background: colors.neutral10 },
          ...(selected &&
            !cleanMode && {
              background: colors.neutral10,
            }),
          '&[data-forcehover=true] .actionButton': {
            opacity: '100% !important',
          },
          '&[data-selected=true] .selectActionButton': {
            opacity: '100% !important',
          },
          ...(onClick && {
            cursor: 'pointer',
            '&:hover': { background: colors.neutral10 },
            ...(selected &&
              !cleanMode && {
                '&:hover': {
                  background: colors.neutral20,
                },
              }),
          }),
          ...(disabled && {
            background: 'transparent',
            pointerEvents: 'none',
            opacity: 0.2,
          }),
          ...(state !== 'idle' && {
            display: 'none',
          }),
        }}
        onClick={onClick}
        onDragEnter={(e) => {
          e.preventDefault()
          e.dataTransfer.dropEffect = 'move'
        }}
      >
        {onOrderChange && (
          <div className="actionButton dn fy a c b da"
          >
            <IconButton
              size="small"
              icon="drag-handle-lines"
              draggable
              // This code is taking care of 2 things:
              // Firstly a bug with browsers where they keep a pointerdown in the initial
              // location of the dragstart, causing hover states to be sticky.
              // To fix this we place a small 2x2 transparent box in that location that sits
              // with a high z-index on top of everything, preventing the unwanted :hover and flickering,
              // Secondly it takes care of custom react based drag previews by injecting a custom react root
              // with a preview element for a few ms.
              onDragStart={(e) => {
                setDraggedItem({ id: item.id, idx })

                const container = document.createElement('div')
                container.style.position = 'fixed'
                container.style.top = '0px'
                container.style.left = '0px'
                container.style.borderLeft = '8px solid transparent'
                container.style.borderTop = '8px solid transparent'
                container.style.pointerEvents = 'none'
                const root = createRoot(container)
                root.render(
                  <DragPreview
                    variant="regular"
                    value={getFirstFieldWithContent(item, fields)}
                  />,
                )
                document.body.append(container)

                queueMicrotask(() => {
                  const rect = container.getBoundingClientRect()
                  container.style.left = `-${rect.width - 0.0001}px`
                })

                e.dataTransfer.setDragImage(container, 0, 0)

                requestAnimationFrame(() => {
                  flushSync(() => {
                    setState('being-dragged-over-self')
                  })

                  root.unmount()
                  document.body.removeChild(container)

                  const pointerBugFixElement = document.createElement('div')
                  pointerBugFixElement.style.position = 'fixed'
                  pointerBugFixElement.style.pointerEvents = 'auto'
                  pointerBugFixElement.style.zIndex = '9999'
                  pointerBugFixElement.style.top = `${pointerPositionRef.current.y - 0.5}px`
                  pointerBugFixElement.style.left = `${pointerPositionRef.current.x - 0.5}px`
                  pointerBugFixElement.style.width = '1px'
                  pointerBugFixElement.style.height = '1px'
                  pointerBugFixElement.style.background = 'transparent'
                  document.body.appendChild(pointerBugFixElement)

                  function cleanup() {
                    document.body.removeChild(pointerBugFixElement)
                  }

                  // TODO: don't destroy my RAM
                  window.addEventListener('pointermove', cleanup, {
                    capture: true,
                    once: true,
                  })
                })
              }}
              onDragEnd={() => {
                setState('idle')
                setDraggedItem(undefined)
              }}
            />
          </div>
        )}
        {onSelectChange && (
          <div className="actionButton selectActionButton dn fy a c b da"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!cleanMode && (
              <CheckboxInput
                value={selected}
                onChange={(value) => {
                  onSelectChange(value)
                }}
                size="small"
              />
            )}
            {cleanMode && (
              <Icon variant={selected ? 'checkmark-normal' : undefined} />
            )}
          </div>
        )}
        <div className="h a1 z a b bl bg"
        >
          {item &&
            Object.values(fields).map((field, index) => {
              const hasContent = Boolean(
                field.render
                  ? field.render(
                      field.renderAccessorFn
                        ? field.renderAccessorFn(item)
                        : item,
                      'table',
                    )
                  : item[field.key],
              )

              if (!hasContent) return null

              return (
                <Fragment key={field.key}>
                  {index !== 0 && !cleanMode && (
                    <div
                      style={{
                        flexShrink: 0,
                        height: 2,
                        width: 2,
                        borderRadius: radius.full,
                        background: colors.neutral60,
                      }}
                    />
                  )}

                  <div className="a c b"
                  >
                    {field.render ? (
                      field.render(
                        field.renderAccessorFn
                          ? field.renderAccessorFn(item)
                          : item,
                        'table',
                      )
                    ) : (
                      <Text
                        singleLine
                        variant="display-medium"
                        color="neutral80"
                      >
                        {item[field.key]}
                      </Text>
                    )}
                  </div>
                </Fragment>
              )
            })}
        </div>

        {React.Children.toArray(
          itemActions
            ?.filter((a) => typeof a.render === 'function')
            .map((a) => (
              <div className="actionButton a2 i3 i4 i5"
                style={{
                  borderRadius: radius[12],
                }}
              >
                {a.render(item)}
              </div>
            )),
        )}
        {itemActions?.filter((a) => typeof a.render !== 'function').length >
          0 && (
          <Menu
          // onOpenChange={(open) => {
          //   setForceHover(open)
          // }}
          >
            <Menu.Trigger>
              <div className="actionButton a a2 c b i3"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                <IconButton
                  icon="more-vertical"
                  size="small"
                  //  forceHover={open}
                />
              </div>
            </Menu.Trigger>
            <Menu.Items>
              {itemActions
                .filter((item) => item.render)
                .map((action, index) => (
                  <Menu.Item
                    key={action.label + '-' + index}
                    leadIcon={action.icon}
                    onClick={() => {
                      action?.onClick(item)
                    }}
                    color={action.color}
                  >
                    {action.label}
                  </Menu.Item>
                ))}
            </Menu.Items>
          </Menu>
        )}
        {!disabled && hover && onRemove && (
          <IconButton
            icon="remove"
            onClick={() => onRemove(idx)}
            tooltip="Remove"
          />
        )}
      </styled.div>
      {draggedOver === 'below' && <ShadowItem />}
    </div>
  )
}

export { ListItem }
export type { ListItemProps }
